/* eslint-disable  @typescript-eslint/no-explicit-any */

"use client";

import { ListItem, Text } from "@stone-payments/jade";
import { Mask } from "@/utils/masks";
import { Skeleton } from "@/components/skeleton";
import { QuantitySelector } from "@/components/quantity-selector";
import { Image } from "@/components/image";

type Props = {
  name: string;
  description: string;
  price: number;
  quantity: number;
  image?: string;
  loading?: boolean;
  onIncrease: () => void;
  onDecrease: () => void;
};

const DrawerCartQuantityLoading = () => {
  return (
    <div
      className="mb-jade-250 flex justify-between"
      aria-label="Quantidade do produto"
    >
      <QuantitySelector loading />
      <Skeleton className="rounded-sm" height="h-12" width="w-20" />
    </div>
  );
};

export const DrawerCartQuantity = ({
  name,
  description,
  image,
  onIncrease,
  onDecrease,
  price,
  quantity,
  loading = false,
}: Props) => {
  if (loading) return <DrawerCartQuantityLoading />;

  return (
    <ListItem
      content={
        <ListItem.Content
          label={name}
          description={
            (
              <Text variant="text-small" weight="semibold" as="span">
                {Mask.formatToBrlCurrency(price)}
              </Text>
            ) as any
          }
          thirdLine={description}
          type="simple"
        />
      }
      leading={<Image src={image} size="xsmall" alt={name} />}
      trailing={
        <QuantitySelector
          quantity={quantity}
          onIncrease={onIncrease}
          onDecrease={onDecrease}
          size="small"
          variant="neutral-ghost"
          removable
        />
      }
    />
  );
};
